import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { get, mapValues, noop } from 'lodash';
import { venomHistory } from 'client/utils/history/venom-history';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  ConsumerReviewsEntities,
  ConsumerReviewsModel,
  ConsumerReviewsPaths,
  DEFAULT_PAGE_NUM,
  NO_STYLE_ID,
} from 'client/data/models/consumer-reviews';
import { buildConsumerReviewsUrl } from 'site-modules/shared/utils/consumer-reviews/url-builder';
import { StyledSelect } from 'client/site-modules/shared/components/styled-select/styled-select';

import './style-select.scss';

function StyleSelectUI({ reviewsFilter, vehicleFilter, modelName, styles, addLoading }) {
  const changeStyle = useCallback(
    style => {
      addLoading();

      setTimeout(() => {
        venomHistory.push(
          buildConsumerReviewsUrl(
            {
              ...reviewsFilter,
              pagenum: DEFAULT_PAGE_NUM,
              aspect: null,
            },
            {
              ...vehicleFilter,
              year: get(style, 'year', vehicleFilter.year),
              styleId: get(style, 'styleId', NO_STYLE_ID),
            }
          )
        );
      }, 0);
    },
    [reviewsFilter, vehicleFilter, addLoading]
  );

  const { styleId: currentStyleId = NO_STYLE_ID } = vehicleFilter;
  const styleSelectLabel = 'style-select-label';

  const stylesTwo = mapValues(styles, (yearArr, year) =>
    yearArr.map(style => ({
      ...style,
      year,
      displayName: `${style.styleName} - (${style.reviewCount} consumer ${
        style.reviewCount === 1 ? 'review' : 'reviews'
      })`,
      disabled: !style.reviewCount,
    }))
  );

  return (
    <Fragment>
      <label id={styleSelectLabel} htmlFor="select-style" className="heading-5">
        {modelName} trim:
      </label>
      <StyledSelect
        value={currentStyleId.toString()}
        optionsGrouped={stylesTwo}
        onChange={changeStyle}
        name="select-style"
        toggle={`All ${modelName} trims`}
        isFirstOptionDisabled={false}
        defaultValue={NO_STYLE_ID}
        valueKey="styleId"
        labelKey="displayName"
        className="style-select rounded heading-5-inline ps-0_5 pe-2_5"
        aria-labelledby={styleSelectLabel}
        data-tracking-id="crr_style_select"
      />
    </Fragment>
  );
}

StyleSelectUI.propTypes = {
  modelName: PropTypes.string.isRequired,
  reviewsFilter: ConsumerReviewsEntities.ReviewsFilter.isRequired,
  vehicleFilter: ConsumerReviewsEntities.VehicleFilter.isRequired,
  styles: ConsumerReviewsEntities.Styles,
  addLoading: PropTypes.func,
};

StyleSelectUI.defaultProps = {
  styles: {},
  addLoading: noop,
};

export const StyleSelect = connectToModel(StyleSelectUI, {
  styles: bindToPath(ConsumerReviewsPaths.getStylesPath(), ConsumerReviewsModel),
});
